import { Icon, IconOffer } from '@flixbus/honeycomb-icons-react';
import { Divider, Heading } from '@flixbus/honeycomb-react';

import styles from './voucher-form-rules.module.scss';

const VoucherFormRulesTitle = () => {
  return (
    <>
      <div className={styles.container}>
        <Heading size={3} extraClasses={styles.title}>
          <span className={styles.icon}>
            <Icon InlineIcon={IconOffer} />
          </span>
          Additional rules <span className={styles.subtext}>(optional)</span>
        </Heading>
      </div>
      <Divider extraClasses={styles.divider} />
    </>
  );
};

export default VoucherFormRulesTitle;
